/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface DatasetDocument
 */
export interface DatasetDocument {
  /**
   *
   * @type {number}
   * @memberof DatasetDocument
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof DatasetDocument
   */
  fileName: string;
  /**
   *
   * @type {string}
   * @memberof DatasetDocument
   */
  file: string;
}

/**
 * Check if a given object implements the DatasetDocument interface.
 */
export function instanceOfDatasetDocument(value: object): value is DatasetDocument {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('fileName' in value) || value['fileName'] === undefined) return false;
  if (!('file' in value) || value['file'] === undefined) return false;
  return true;
}

export function DatasetDocumentFromJSON(json: any): DatasetDocument {
  return DatasetDocumentFromJSONTyped(json, false);
}

export function DatasetDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatasetDocument {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    fileName: json['file_name'],
    file: json['file'],
  };
}

export function DatasetDocumentToJSON(value?: Omit<DatasetDocument, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    file_name: value['fileName'],
    file: value['file'],
  };
}
